//export const BASE_URL = "http://localhost:4000/"; //(this for local build)
//export const BASE_URL = "https://www.glintler.com:4020/"; //(this for dev build)
// export const BASE_URL = "http://97.74.89.245:4020/"; //(this for dev build)
export const BASE_URL = "https://www.glintler.com:4000/";//(this for production build)
// export const BASE_URL_RISKMAP = "http://172.16.0.243:4020/"
export const BASE_URL_RISKMAP = "https://www.glintler.com:4000/";


//export const BASE_URL_LIVE = "http://localhost:4000/"; //(this for local build)
 //export const BASE_URL_LIVE = "https://www.glintler.com:4020/"; //(this for dev build)
export const BASE_URL_LIVE = "https://www.glintler.com:4000/"; //(this for live build)

export const REAL_API_URL = 'https://www.glintler.in:8099';
export const BASE_URL_WORKSPACE = 'https://www.glintler.com:4030/api';



// export const Local_URL = "http://localhost:4000/";
//export const HOME_APP_URL = "http://localhost:3000"; //(this for local build)
export const AI_AGENT_URL = "https://www.refine.finance/finreport";
// export const HOME_APP_URL = "http://localhost:3000/refine_uae"; //(this for local build)
//export const HOME_APP_URL = "https://www.glintler.com/refine_mapping_1_0"; //(this for dev build)
export const HOME_APP_URL = "https://www.refine.finance";//(this for production build)


// export const ADMIN_API_URL = "https://devapi.glintler.com"; //(this for local build)
// export const ADMIN_API_URL = "https://glintler.in:3060"; //(this for dev build)
// export const ADMIN_API_URL = "https://www.glintler.com:5020/"; //(this for production build)
export const ADMIN_API_URL = "https://www.glintler.com:5020/"; //(this for production build)


export const BASE_URL_AI_INSIGHTS = "https://www.glintler.in:5050/api";

//export const COOKIES_DOMAIN = "localhost"; //(this for local build)
//export const COOKIES_DOMAIN = "glintler.com";//(this for dev build)
export const COOKIES_DOMAIN = "refine.finance";//(this for production build)

// export const NEWS_FILING_API = "http:localhost:8099";

//export const SOCKET_URL = "http://localhost:4000"; //(this for local build)
//export const SOCKET_URL = "https://www.glintler.com:4020"; //(this for dev build)
//export const SOCKET_URL = "https://www.glintler.com:4000"; //(this for production build)

export const DEFAULT_CHECK_NUMBER = 330;
export const PUBLIC_KEY = randomString();
export const RANDOM_STRING = randomString();
export const DEFAULT_USER_ID = 42;
export const PRIVATE_KEY = "GlinterIndia2018";
export const REFINE_PRIVATE_KEY = "Refine2025India";
export const LIFECYCLE_MULTIPLIER = 1.3;
function randomString() {
  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  var string_length = 8;
  var randomstring = "";
  for (var i = 0; i < string_length; i++) {
    var rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}
export const BG_COLOUR = [
  "#4562ea",
  "#3fe5d1",
  "#ebce42",
  "#e37b3e",
  "#e23ba5",
  "#38c845",
  "#dd3131",
  "#666666",
  "#8599f0",
  "#9cf3ed",
  "#f3dd88",
  "#dfb390",
  "#ed7fc6",
  "#79dd83",
  "#ea7676",
  "#9b9b9b",
  "#354799",
  "#319589",
  "#9a8931",
  "#98542f",
  "#943172",
  "#2e843b",
  "#902c2e",
  "#464646",
  "#9966CC",
  "#008080",
  "#FFF0F5",
  "#6699CC",
  "#003153",
  "#CD5700",
  "#8F8B66",
];
export const CASHFLOW_FORMAT = [
  "operating cash margin",
  "(invested)/generated from net working assets",
  "net capex",
  "taxation",
  "debt service cost paid",
  "dividend & dividend tax paid",
  "investments/loans & advances",
  "increase/(decrease) in equity",
  "increase/(decrease) in debt",
  "(increase)/decrease in cash",
  "exceptional items",
  "other financing related items",
];
export const COST_SPLIT_TO_REVENUE = [
  "Revenue",
  "Cost of Sales",
  "Expenses",
  "Exceptional item",
  "Taxation Expense",
  "Net Profit After Tax",
  "Minority Interest/Associate Profit and Loss",
];
export const CASHFLOW = [
  "net cash generations from operating activities",
  "net cash generations from investing activities",
  "net cash generation from financing activities",
  "net increase/(decrease) in cash and cash equivalents",
  "exceptional items",
];
export const TOTAL_OUTSTANDING_SHARE_FUTURE =
  "total_outstanding_share_including_future_commitement";
export const FREECASHFLOW = [
  "operating cash margin",
  "(invested)/generated from net working assets",
  "net capex",
  "taxation",
  "debt service cost paid",
];
export const TABLEONLY = [
  "Share Price vs Dow jones performance",
  "Stock performance Chart",
  "Earning Yield Comparison",
  "Comparative Price to Earning",
  "Net Asset Value Comparisons",
  "Free Cash Flow Based Valuation",
  "Market Cap Co-relation with Underlying Business",
  "Revenue Profile",
  "Revenue Progression Drivers",
  "Revenue Progression Drivers %",
  "Revenue Profile (% of Total)",
  "P&L Profile for the Company",
  "Opex Profile for the Company",
  "Margin % (Cash Flow Vs P&L)",
  "Sources and Uses of Cash Flow",
  "Sources and Uses of Equity",
  "Return on Equity",
  "Return on Capital Employed",
];
export const TABLEGRAPH = [
  "Contigent Liabilities",
  "Market Capitalization Evolution",
  "Price to Book Value/Price to Sales",
  "Capitalization Structure (Debt & Equity)",
  "Debt to Equity in Capital Structure",
  "Borrowing Profile for the Company",
  "Debt Service Costs Materiality",
  "Debt Service Capability",
  "Operational Metrics",
  "Capex needs for business",
  "Earning before Interest and Tax (EBIT)",
  "Net Profit After Tax",
  "Earning Per Share",
  "Reported Cash Flow Metrics",
  "Reported Cash Flow Metrics",
  "Dividends",
];
export const GRAPHONLY = [
  "Stock Performance Vis-a-Vis Index",
  "Total outstanding share including future commitment",
  "Price Earning Ratio",
  "Cash Flow Yields",
  "Borrowing to Equity Ratio/Total Liabilities to Equity Ratio",
  "Borrowing Profile (% of Total)",
  "Borrowing Interest % for the Company",
  "Depreciation/Amortization for the Company",
  "Current Asset and Acid Test Ratio",
  "Taxation As % of Profit Before Tax",
  "Tax Assets & Liabilities",
  "Exceptional Items Cash Flow And P&L",
  "Sources of Cash Flow",
  "Usage of Cash Flow",
  "Free Cash Flows (W/o Exceptional Items)",
  "Dividend & Dividend Tax (Cash Flow Vs P&L)",
  "Sources of Equity",
  "Usage of Equity",
  "Utilization of Retained Earning",
  "Promoter Shareholding",
  "Managerial Compensation",
  "Sources of Related Party Transaction",
  "Uses of Related Party Transaction",
  "Related Party Transaction",
  "Taxation As % of Profit Before Tax",
  "Margin % (Cash Flow Vs P&L)",
];
export const graphColors = [
  "#1095FC",
  "#BDA277",
  "#FDBE61",
  "#7793A8",
  "#7E776D",
  "#51E3A4",
  "#398ECE",
  "#FB7760",
  "#77A692",
  "#D07262",
  "#3E44D0",
  "#BEF5DD",
  "#F5C7BF",
  "#A2CCBA",
  "#9C685F",
  "#3D755D",
  "#521B11",
  "#D1B53F",
  "#7D6A1A",
  "#CF943A",
  "#022D4F",
  "#CBB28A",
  "#954133",
  "#7D7966",
  "#F2C60D",
  "#6ABBFB",
  "#AD8B85",
  "#179860",
  "#ADD0EB",
  "#F0ECDB",
  "#C27D70",
  "#13EC8F",
  "#D8C3C0",
  "#8FA39A",
  "#F92F0B",
  "#7B561E",
];

export const currencytext = {
  INR: "Rs.",
  USD: "$",
  RM: "RM",
  EUR: "€",
  CHF: "CHF",
  SEK: "SEK",
  THB: "฿",
  TWD: "NT$",
  AED: "AED",
  CAD: "CAD"
};

export function stringToColor(str) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const color = `hsl(${hash % 360}, 60%, 45%)`;
  return color;
}

export const defaultPortfolioList = [
  {
    portfolio_name: 'Fab 7',
    portfolio_text_id: 'FAB7D1',
    user_id: null, // null for default portfolios
    created_at: '2024-08-14T04:59:55.000Z',
    isDefault: true
  },
  {
    portfolio_name: 'Semiconductor companies in US',
    portfolio_text_id: 'SEMI01',
    user_id: null,
    created_at: '2024-08-14T04:59:55.000Z',
    isDefault: true
  },
  {
    portfolio_name: 'Paint Companies in India',
    portfolio_text_id: 'PAINT1',
    user_id: null,
    created_at: '2024-08-14T04:59:55.000Z',
    isDefault: true
  },
  {
    portfolio_name: 'Cyber Security Companies in US',
    portfolio_text_id: 'CYBER1',
    user_id: null,
    created_at: '2024-08-14T04:59:55.000Z',
    isDefault: true
  },
  {
    portfolio_name: 'Genomics Companies in US',
    portfolio_text_id: 'GENOM1',
    user_id: null,
    created_at: '2024-08-14T04:59:55.000Z',
    isDefault: true
  },
  {
    portfolio_name: 'Equal Weighted Portfolio in Dubai',
    portfolio_text_id: 'DFM001',
    user_id: null,
    created_at: '2024-08-14T04:59:55.000Z',
    isDefault: true
  }
];

export const defaultPortfolioDetails = {
  'FAB7D1': {
    portfolio_name: 'Fab 7',
    portfolio_text_id: 'FAB7D1',
    user_id: null,
    transactions: [
      {
        transaction_text_id: 'FAB101',
        company_id: 32,
        company_name: 'Amazon',
        transaction_type: 'buy',
        quantity: 10,
        price_per_share: '17.58',
        transaction_date: '2014-02-24',
        total_value: '1000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'FAB102',
        company_id: 27,
        company_name: 'Apple',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '18.84',
        transaction_date: '2014-02-24',
        total_value: '2000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'FAB103',
        company_id: 38,
        company_name: 'META',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '105.13',
        transaction_date: '2015-11-17',
        total_value: '2000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'FAB104',
        company_id: 39,
        company_name: 'MICROSOFT CORPORATION',
        transaction_type: 'buy',
        quantity: 10,
        price_per_share: '37.69',
        transaction_date: '2014-02-24',
        total_value: '1000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'FAB105',
        company_id: 59,
        company_name: 'NVIDIA CORP',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '0.47',
        transaction_date: '2014-02-24',
        total_value: '9.4',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'FAB106',
        company_id: 49,
        company_name: 'Tesla',
        transaction_type: 'buy',
        quantity: 10,
        price_per_share: '14.51',
        transaction_date: '2014-02-24',
        total_value: '1000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'FAB107',
        company_id: 40,
        company_name: 'Alphabet Inc',
        transaction_type: 'buy',
        quantity: 10,
        price_per_share: '30.31',
        transaction_date: '2014-02-24',
        total_value: '1000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      }
    ]
  },

  'SEMI01': {
    portfolio_name: 'Semiconductor companies in US',
    portfolio_text_id: 'SEMI01',
    user_id: null,
    transactions: [
      {
        transaction_text_id: 'SEMI11',
        company_id: 59,
        company_name: 'NVIDIA CORP',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '0.47',
        transaction_date: '2014-02-24',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'SEMI12',
        company_id: 116,
        company_name: 'AMD',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '3.71',
        transaction_date: '2014-02-24',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'SEMI13',
        company_id: 118,
        company_name: 'Broadcom',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '5.95',
        transaction_date: '2014-02-24',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'SEMI14',
        company_id: 101,
        company_name: 'Qualcomm',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '75.43',
        transaction_date: '2014-02-24',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'SEMI15',
        company_id: 1255,
        company_name: 'Intel Corporation',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '24.63',
        transaction_date: '2014-02-24',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      }
    ]
  },

  'PAINT1': {
    portfolio_name: 'Paint Companies in India',
    portfolio_text_id: 'PAINT1',
    user_id: null,
    transactions: [
      {
        transaction_text_id: 'PAINT11',
        company_id: 16,
        company_name: 'Asian Paints',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '538.2',
        transaction_date: '2014-05-12',
        total_value: '2500.00',
        currency: 'INR',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'PAINT12',
        company_id: 17,
        company_name: 'Berger Paints',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '418.95',
        transaction_date: '2020-06-02',
        total_value: '2500.00',
        currency: 'INR',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'PAINT13',
        company_id: 76,
        company_name: 'Indigo Paints',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '2433',
        transaction_date: '2021-08-20',
        total_value: '2500.00',
        currency: 'INR',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'PAINT14',
        company_id: 35,
        company_name: 'Kansai Nerolac Paint Limited',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '84.93',
        transaction_date: '2014-05-12',
        total_value: '2500.00',
        currency: 'INR',
        created_at: '2024-08-14T04:59:55.000Z'
      }
    ]
  },

  'CYBER1': {
    portfolio_name: 'Cyber Security',
    portfolio_text_id: 'CYBER1',
    user_id: null,
    transactions: [
      {
        transaction_text_id: 'CYBER11',
        company_id: 78,
        company_name: 'Crowdstrike',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '58',
        transaction_date: '2019-06-12',
        total_value: '2000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'CYBER12',
        company_id: 79,
        company_name: 'SentinelOne',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '8.4',
        transaction_date: '2014-02-24',
        total_value: '2000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'CYBER13',
        company_id: 80,
        company_name: 'Qualys',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '26.49',
        transaction_date: '2014-02-24',
        total_value: '2000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'CYBER14',
        company_id: 81,
        company_name: 'Palo Alto',
        transaction_type: 'buy',
        quantity: 20,
        price_per_share: '12.79',
        transaction_date: '2014-02-24',
        total_value: '2000.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      // {
      //   transaction_text_id: 'CYBER15',
      //   company_id: 82,
      //   company_name: 'Zscaler',
      //   transaction_type: 'buy',
      //   quantity: 20,
      //   price_per_share: '100.00',
      //   transaction_date: '2014-02-24',
      //   total_value: '2000.00',
      //   currency: 'USD',
      //   created_at: '2024-08-14T04:59:55.000Z'
      // }
    ]
  },

  'GENOM1': {
    portfolio_name: 'Genomics Companies in US',
    portfolio_text_id: 'GENOM1',
    user_id: null,
    transactions: [
      {
        transaction_text_id: 'GENOM11',
        company_id: 57,
        company_name: 'CRISPR',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '38.5',
        transaction_date: '2020-04-01',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'GENOM12',
        company_id: 102,
        company_name: 'INTELLIA THERAPEUTICS INC',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '22.1',
        transaction_date: '2016-05-06',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'GENOM13',
        company_id: 104,
        company_name: 'Editas Medicine',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '18.2',
        transaction_date: '2016-02-03',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'GENOM14',
        company_id: 105,
        company_name: 'Beam Therapeutics',
        transaction_type: 'buy',
        quantity: 25,
        price_per_share: '18.75',
        transaction_date: '2020-02-06',
        total_value: '2500.00',
        currency: 'USD',
        created_at: '2024-08-14T04:59:55.000Z'
      }
    ]
  },
  'DFM001': {
    portfolio_name: 'Equal Weighted Portfolio in Dubai',
    portfolio_text_id: 'DFM001',
    user_id: null,
    transactions: [
      {
        transaction_text_id: 'DFM0001',
        company_id: 1642,
        company_name: 'Emaar Properties PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '4.23',
        transaction_date: '2020-01-15',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0002',
        company_id: 1646,
        company_name: 'Agility The Public Warehousing Company K.S.C',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '1.55',
        transaction_date: '2020-01-16',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0003',
        company_id: 1647,
        company_name: 'Salik Company PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '2.20',
        transaction_date: '2022-10-03',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0004',
        company_id: 1648,
        company_name: 'Air Arabia PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '1.60',
        transaction_date: '2020-01-15',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0005',
        company_id: 1655,
        company_name: 'Invictus investment company plc',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '3.82',
        transaction_date: '2022-12-30',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0006',
        company_id: 1657,
        company_name: 'EMAAR DEVELOPMENT PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '3.89',
        transaction_date: '2020-01-16',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0007',
        company_id: 1663,
        company_name: 'ALEC Holdings PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '1.40',
        transaction_date: '2022-10-17',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0008',
        company_id: 1665,
        company_name: 'Parkin Company PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '2.84',
        transaction_date: '2024-03-21',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      },
      {
        transaction_text_id: 'DFM0009',
        company_id: 1666,
        company_name: 'Dubai Electricity & Water Authority PJSC',
        transaction_type: 'buy',
        quantity: 100,
        price_per_share: '2.60',
        transaction_date: '2022-06-15',
        total_value: '1000.00',
        currency: 'AED',
        created_at: '2024-08-14T04:59:55.000Z'
      }
    ]
  }
};


export const ALLOWED_USERS = [42, 38]




export const getDefaultPortfolioDetails = (portfolio_text_id) => {
  const details = defaultPortfolioDetails[portfolio_text_id];


  if (!details) {
    return null;
  }
  return {
    success: true,
    data: [details]
  };
};

export const getDefaultPortfolioList = () => {
  return {
    success: true,
    data: defaultPortfolioList
  };
};
